import React, { Component, createRef } from 'react';
import { branch } from 'baobab-react/higher-order';

import { editAgent } from '../../../store/struct/entities/agent/actions';
import { editClient } from '../../../store/struct/entities/client/actions';
import {
  agentsSelector,
  clientsSelector,
  clientInfoSelector,
  institutionsSelector,
  positionsSelector,
  teamsSelector,
} from '../../../store/struct/selectors';
import STRUCT from '../../../store/struct/entities';
import USER_STRUCT from '../../../store/struct/entities/user';
import TEAM_STRUCT from '../../../store/struct/entities/team';
import INFO_STRUCT from '../../../store/struct/entities/clientInfo';
import GAME_STRUCT, {
  GAME_STATUS as STATUS,
} from '../../../store/struct/entities/game';
import { getById } from '../../../utils';

import Table, { TYPES as TABLE_TYPES } from '../../../components/table';
import Form, { TYPES as FORM_TYPES } from '../../../components/form';
import { SUBTYPES } from '../../../components/form/input';
import Select from '../../../components/form/select';
import Dialog from '../../../components/dialog';

import styles from '../index.module.scss';

const HEADERS = ['ФИО', 'ПИН', 'Роль', ''];

class Users extends Component {
  state = {
    showDialog: false,
  };

  formConfig = [];
  formData = null;
  form = createRef();

  editUser = data => {
    this.formConfig = this.getFormConfig(data);
    this.formData = data;
    this.setState({ showDialog: true });
  };

  closeDialog = () => {
    this.formConfig = [];
    this.formData = null;
    this.setState({ showDialog: false });
  };

  saveUser = () => {
    const data = {
      [USER_STRUCT.ID]: this.formData[USER_STRUCT.ID],
      ...this.form.current.getState(),
    };

    if (USER_STRUCT.TEAM_ID in this.formData) {
      this.props.dispatch(editAgent, data);
    } else {
      // todo update info
      const { [STRUCT.CLIENT_INFO]: info, ...restData } = data;

      this.props.dispatch(editClient, restData);
    }
    this.closeDialog();
  };

  tableConfig = [
    {
      type: TABLE_TYPES.TEXT,
      getValue: data => data[USER_STRUCT.NAME],
    },
    {
      type: TABLE_TYPES.TEXT,
      getValue: data => data[USER_STRUCT.PIN],
    },
    {
      type: TABLE_TYPES.TEXT,
      getValue: data => {
        const { positions, institutions } = this.props;

        return data.isAgent
          ? 'Представитель'
          : `${getById(positions, data[USER_STRUCT.POSITION_ID]).title}, ${
              getById(institutions, data[USER_STRUCT.INSTITUTION_ID]).title
            }`;
      },
    },
    {
      type: TABLE_TYPES.BUTTON,
      onClick: this.editUser,
      text: 'Редактировать',
      min: true,
      getProps: () => ({
        disabled: this.disabled(),
      }),
    },
  ];

  getFormConfig = data => {
    const { positions, institutions, clientInfo } = this.props;

    return USER_STRUCT.POSITION_ID in data
      ? [
          {
            id: USER_STRUCT.NAME,
            title: 'ФИО пользователя:',
            type: FORM_TYPES.INPUT,
            initialValue: data[USER_STRUCT.NAME],
            className: styles.fullWidth,
          },
          {
            id: USER_STRUCT.POSITION_ID,
            title: 'Должность:',
            type: FORM_TYPES.INPUT,
            initialValue: getById(positions, data[USER_STRUCT.POSITION_ID])
              .title,
            readonly: true,
            stateless: true,
          },
          {
            id: USER_STRUCT.INSTITUTION_ID,
            title: 'Лечебное заведение:',
            type: FORM_TYPES.INPUT,
            initialValue: getById(
              institutions,
              data[USER_STRUCT.INSTITUTION_ID],
            ).title,
            readonly: true,
            stateless: true,
          },
          {
            id: USER_STRUCT.RULES,
            title: 'Возможности и ограничения Должности:',
            type: FORM_TYPES.INPUT,
            subtype: SUBTYPES.TEXTAREA,
            initialValue: data[USER_STRUCT.RULES],
            attrs: {
              rows: 5,
            },
          },
          {
            id: STRUCT.CLIENT_INFO,
            title: 'Аргументы:',
            type: FORM_TYPES.INPUT,
            subtype: SUBTYPES.TEXTAREA,
            initialValue: clientInfo
              .filter(
                info => info[INFO_STRUCT.CLIENT_ID] === data[USER_STRUCT.ID],
              )
              .map(info => info[INFO_STRUCT.BRIEF])
              .join('\n'),
            readonly: true, // todo temporarily make it readonly
            stateless: true,
            attrs: {
              rows: 5,
            },
          },
        ]
      : [
          {
            id: USER_STRUCT.NAME,
            title: 'ФИО пользователя:',
            type: FORM_TYPES.INPUT,
            initialValue: data[USER_STRUCT.NAME],
            className: styles.fullWidth,
          },
          {
            id: USER_STRUCT.GOAL,
            title: 'Целевой показатель:',
            type: FORM_TYPES.INPUT,
            initialValue: data[USER_STRUCT.GOAL],
            attrs: {
              type: 'number',
            },
          },
        ];
  };

  disabled = () => {
    const { currentGame } = this.props;

    return currentGame[GAME_STRUCT.STATUS_ID] !== STATUS.DEFAULT;
  };

  render() {
    const {
      gamesOptions,
      currentGameId,
      setCurrentGameId,
      clients,
      agents,
      teams,
    } = this.props;
    const { showDialog } = this.state;

    const currentTeamsIds = teams
      .filter(team => team[TEAM_STRUCT.GAME_ID] === currentGameId)
      .map(team => team[TEAM_STRUCT.ID]);

    const currentClients = clients
      .filter(client => client[USER_STRUCT.GAME_ID] === currentGameId)
      .map(client => ({
        ...client,
        key: `${client[USER_STRUCT.ID]}_${STRUCT.CLIENT}`,
      }));
    const currentAgents = agents
      .filter(agent => currentTeamsIds.indexOf(agent[USER_STRUCT.TEAM_ID]) > -1)
      .map(client => ({
        ...client,
        key: `${client[USER_STRUCT.ID]}_${STRUCT.AGENT}`,
        isAgent: true,
      }));

    return (
      <>
        <div className={styles.block}>
          <Select
            onChange={setCurrentGameId}
            options={gamesOptions}
            value={currentGameId}
            attrs={{ disabled: gamesOptions.length === 0 }}
            placeholder='Выбрать игру'
          />
        </div>
        {/*<h2>Список пользователей</h2>*/}
        {currentGameId !== null ? (
          <Table
            className={styles.tableWithControl}
            headers={HEADERS}
            config={this.tableConfig}
            data={currentClients.concat(currentAgents)}
          />
        ) : (
          <div>
            Для того, чтобы открыть список пользователей, необходимо выбрать
            игру.
          </div>
        )}
        {showDialog && (
          <Dialog
            title='Редактирование пользователя'
            submitTitle='Сохранить пользователя'
            onSubmit={this.saveUser}
            cancelTitle='Отменить'
            onCancel={this.closeDialog}
          >
            <Form ref={this.form} config={this.formConfig} />
          </Dialog>
        )}
      </>
    );
  }
}

export default branch(
  {
    clients: clientsSelector(),
    agents: agentsSelector(),
    teams: teamsSelector(),
    positions: positionsSelector(),
    institutions: institutionsSelector(),
    clientInfo: clientInfoSelector(),
  },
  Users,
);
